// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1SZNM","label":"Completed_label__26ClX"};